import React from 'react';
import { Button } from '@mui/material';
import { CheckCircle as PostIcon } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateWriteoffMutation } from '../../../../services/WriteoffService';
import { clearBackupAction as clearBackup } from '../../../../services/WriteoffService/slice';
import { useNavigate } from 'react-router-dom';

interface PostButtonProps {
  onError?: (message: string) => void;
}

export const PostButton: React.FC<PostButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentWriteoff, isEdited } = useAppSelector(state => state.writeoff);
  const [updateWriteoffMutation, { isLoading }] = useUpdateWriteoffMutation();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const isVisible = currentWriteoff?.status?.toUpperCase() === 'APPROVED';

  if (!isVisible) return null;

  const handlePost = async () => {
    if (!currentWriteoff) return;

    const modifiedBy = account?.name || account?.username || 'System';
    const writeoffForPost = {
      ...currentWriteoff,
      status: 'POSTED',
      modifiedBy
    };

    try {
      await updateWriteoffMutation({ writeoffView: writeoffForPost }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to post writeoff. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<PostIcon />}
      onClick={handlePost}
      disabled={isLoading || isEdited}
      sx={{
        backgroundColor: '#7c3aed',
        '&:hover': { backgroundColor: '#6d28d9' },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Posting...' : 'Post Writeoff'}
    </Button>
  );
};

export default PostButton;
